module.exports = __webpack_public_path__ + "img/Logo_Parque_Arauco.svg.34ce3853.png";